import { useAppSelector } from "../redux/store";

const GetStepperLabels = () => {
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const { pageText }: any = customerJourney;
  const stepperLabels: any = {
    location: pageText?.journeyNavigatorMetadata.selectLocation,
    examDetails: pageText?.journeyNavigatorMetadata.selectExamDate,
    termsAndConditions: `${pageText?.textMetadata?.plzread} - ${pageText?.journeyNavigatorMetadata.termsAndConditions}`,
    candidateData: pageText?.journeyNavigatorMetadata.candidateDetails,
    confirmation: pageText?.journeyNavigatorMetadata.confirmAndRegister,
  };

  return pageText ? stepperLabels : {};
};

export default GetStepperLabels;
